<template>
  <div class="future-box">
    <banner-box />
    <introduction />
    <links />
    <div class="zhuzhai">
      <z-title>住宅関連</z-title>
      <img class="zhuzhai1" :src="zhuzhai1" alt="" />
       <p class="sub-title">住宅建築についての構想</p>
      <p class="word" style="margin-left: 352px;margin-top: 12px;">日本では木造家屋が一般的です。必要な建築資材をまとめて
販売することで効率的な建築ができればと考えております。</p>
      <p class="word">1、必要なすべての建築資材（ビーム、間柱、垂木、フリー
ボードなど）を建築物の設計図に基づいて生産</p>
      <p class="word">2、コンテナを利用して大連工場から運送 <br />
一般的な一軒家に必要な建築資材は約18㎥ <br />
40ftコンテナを使用すれば2軒分積載可能</p>
      <p class="word">3、日本倉庫に到着後、お客様のご要望に応じて現場へ配送 <br />
建築資材の一括購入で大幅に効率化を実現</p>
      <p class="sub-title title1">住宅建築に関連する製品</p>
      <p class="word word1">住宅建築に関連する製品の物流倉庫を設立し、一括管理し、
        段階的な配送を実現し、一戸一セットの配達プランを目指しています。</p>
      <div class="rows">
        <p class="row">
          <span class="name">プレカット</span>
          <span class="value">大連工場のプレカット技術は中国東北地方の同業者
と比べて群を抜く存在です。特注生産も承ります。</span>
        </p>
        <p class="line"></p>
        <p class="row">
          <span class="name">間柱、垂木など </span>
          <span class="value">一戸建て関連製品のプレカットだけでなく、ホームセ
ンター向けの木製建築資材倉庫も所有しています。</span>
        </p>
      </div>
      <p class="sub-title">木造建築関連製品</p>
      <div class="img-box">
        <img :src="zhuzhai2" alt="" />
        <img class="zhuzhai3" :src="zhuzhai3" alt="" />
      </div>
    </div>
    <z-title>日本に建築資材倉庫を設立する構想</z-title>
    <div class="items">
      <p
        v-for="(item, index) in cangkuData"
        class="item"
        :key="index"
      >
        <img class="img" :src="item.url" alt="" />
      </p>
    </div>
    <z-title class="title2">日本で生産工場を設立する構想</z-title>
    <p class="title3">日本産の針葉樹、広葉樹の原材料を十分に活用した生産工場を設立して、「メイド・イン・ジャパン」商品を開発します。</p>
    <img :src="cangku5" alt="" class="cangku5" />
  </div>
</template>

<script>
import introduction from '../../components/introduction'
import links from './components/links'
export default {
  name: 'index',
  components: {
    introduction,
    links
  },
  data () {
    const {
      future: {
        zhuzhai1,
        zhuzhai2,
        zhuzhai3,
        cangku1,
        cangku2,
        cangku3,
        cangku4,
        cangku5
      }
    } = this.$images
    return {
      zhuzhai1,
      zhuzhai2,
      zhuzhai3,
      cangku5,
      cangkuData: [
        { url: cangku1 },
        { url: cangku2 },
        { url: cangku3 },
        { url: cangku4 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.future-box{
  display: flex;
  flex-direction: column;

  /deep/ .banner-box{
    width: 1559px;
    margin-left: 192px;
  }

  .zhuzhai{
    display: flex;
    flex-direction: column;
    position: relative;
    padding-top: 72px;

    .sub-title{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 24px;
      color: #374475;
      line-height: 48px;
      margin-left: 355px;
      margin-top: 32px;
      padding-left: 18px;

      position: relative;

      &.title1{
        margin-top: 50px;
      }

      &:before{
        content: '';
        position: absolute;
        top: 20px;
        left: 0px;
        width: 5px;
        height: 5px;
        background: #374475;
        border-radius: 50%;
      }
    }
    .zhuzhai1{
      position: absolute;
      top: 109px;
      right: 128px;
    }
    .word{
      width: 668px;
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 30px;
      margin-left: 352px;
      margin-bottom: 28px;
    }

    .word1{
      width: 648px;
      padding-left: 20px;
    }

    .rows{
      display: flex;
      flex-direction: row;
      margin-left: 375px;

      .row{
        display: flex;
        flex-direction: column;

        .name{
          font-weight: 400;
          font-size: 24px;
          color: #333333;
          line-height: 30px;
        }

        .value{
          width: 491px;
          font-family: 04KanjyukuGothic;
          font-weight: 400;
          font-size: 20px;
          color: #333333;
          line-height: 30px;
          margin-top: 10px;
        }
      }

      .line{
        width: 1px;
        height: 91px;
        background-color: #A9A9A9;
        margin: 4px 119px 0px 109px;
      }
    }

    .img-box{
      margin-left: 372px;

      .zhuzhai3{
        margin-left: 134px;
      }
    }
  }

  .items{
    width: 1411px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-left: 258px;
    margin-top: 53px;

    .item{
      .img{
        width: 348px;
      }
    }
  }
  .title2{
    margin-top: 52px;
  }
  .title3{
    width: 1116px;
    font-family: 04KanjyukuGothic;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 30px;
    margin-top: 49px;
    margin-left: 347px;
  }
  .cangku5{
    width: 1165px;
    height: 775px;
    margin-top: 31px;
    margin-bottom: 74px;
    margin-left: 378px;
  }
}
</style>
